<div class="modal-header">
	<h4 class="modal-title">
		<i class="bi bi-person-circle me-2"></i>
		Omat tiedot
	</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="activeModal.dismiss()"
	></button>
</div>

<div class="modal-body" *ngIf="editingUser">
	<!-- Loading overlay -->
	<div class="modal-spinner-overlay" *ngIf="isLoading">
		<div class="spinner-container">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Ladataan...</span>
			</div>
			<p class="mt-2 mb-0">Päivitetään käyttäjätietoja...</p>
		</div>
	</div>

	<!-- Error messages -->
	<div *ngIf="errors.length > 0" class="alert alert-danger" role="alert">
		<h6 class="alert-heading">
			<i class="bi bi-exclamation-triangle-fill me-2"></i>
			Virhe käyttäjätietojen päivityksessä:
		</h6>
		<ul class="mb-0">
			<li *ngFor="let error of errors">{{ error }}</li>
		</ul>
	</div>

	<form>
		<!-- Personal Information Section -->
		<h6 class="text-muted mb-3">
			<i class="bi bi-person me-2"></i>
			Henkilötiedot
		</h6>

		<div class="row">
			<div class="col-md-6 mb-3">
				<label for="editFirstName" class="form-label">
					Etunimi <span class="text-danger">*</span>
				</label>
				<input
					type="text"
					class="form-control"
					id="editFirstName"
					[(ngModel)]="editingUser.firstName"
					name="editFirstName"
					required
					[disabled]="isLoading"
				/>
			</div>
			<div class="col-md-6 mb-3">
				<label for="editLastName" class="form-label">
					Sukunimi <span class="text-danger">*</span>
				</label>
				<input
					type="text"
					class="form-control"
					id="editLastName"
					[(ngModel)]="editingUser.lastName"
					name="editLastName"
					required
					[disabled]="isLoading"
				/>
			</div>
		</div>

		<div class="mb-4">
			<label for="editEmail" class="form-label">
				Sähköposti <span class="text-danger">*</span>
			</label>
			<input
				type="email"
				class="form-control"
				id="editEmail"
				[(ngModel)]="editingUser.email"
				name="editEmail"
				required
				[disabled]="isLoading"
			/>
		</div>

		<!-- Password Change Section -->
		<h6 class="text-muted mb-3">
			<i class="bi bi-key me-2"></i>
			Salasanan vaihto
			<small class="text-muted">(valinnainen)</small>
		</h6>

		<div class="mb-3">
			<label for="editOldPassword" class="form-label">
				Nykyinen salasana
				<span class="text-danger" *ngIf="isChangingPassword">*</span>
			</label>
			<div class="input-group">
				<input
					[type]="showOldPassword ? 'text' : 'password'"
					class="form-control"
					id="editOldPassword"
					[(ngModel)]="editingUser.oldPassword"
					name="editOldPassword"
					placeholder="Syötä nykyinen salasana vaihtaaksesi sen"
					[disabled]="isLoading"
				/>
				<button
					class="btn btn-outline-secondary"
					type="button"
					(click)="toggleOldPasswordVisibility()"
					[disabled]="isLoading"
					title="Näytä/piilota salasana"
				>
					<i
						class="bi"
						[ngClass]="{
							'bi-eye': !showOldPassword,
							'bi-eye-slash': showOldPassword,
						}"
					></i>
				</button>
			</div>
		</div>

		<div class="mb-3">
			<label for="editNewPassword" class="form-label">
				Uusi salasana
			</label>
			<div class="input-group">
				<input
					[type]="showNewPassword ? 'text' : 'password'"
					class="form-control"
					id="editNewPassword"
					[(ngModel)]="editingUser.newPassword"
					name="editNewPassword"
					placeholder="Syötä uusi salasana (jätä tyhjäksi jos et halua vaihtaa)"
					[disabled]="isLoading"
				/>
				<button
					class="btn btn-outline-secondary"
					type="button"
					(click)="toggleNewPasswordVisibility()"
					[disabled]="isLoading"
					title="Näytä/piilota salasana"
				>
					<i
						class="bi"
						[ngClass]="{
							'bi-eye': !showNewPassword,
							'bi-eye-slash': showNewPassword,
						}"
					></i>
				</button>
			</div>
			<div class="form-text">
				<i class="bi bi-info-circle me-1"></i>
				Salasanan tulee sisältää vähintään 8 merkkiä, isoja ja pieniä
				kirjaimia, numeroita ja erikoismerkkejä.
			</div>
		</div>

		<!-- Clear password button -->
		<!-- <div class="mb-3" *ngIf="isChangingPassword">
			<button
				type="button"
				class="btn btn-outline-secondary btn-sm"
				(click)="clearNewPassword()"
				[disabled]="isLoading"
			>
				<i class="bi bi-x-circle me-1"></i>
				Peruuta salasanan vaihto
			</button>
		</div> -->
	</form>
</div>

<div class="modal-footer">
	<button
		type="button"
		class="btn btn-secondary"
		(click)="cancel()"
		[disabled]="isLoading"
	>
		Peruuta
	</button>
	<button
		type="button"
		class="btn btn-primary"
		(click)="updateUser()"
		[disabled]="isLoading"
	>
		<span
			*ngIf="isLoading"
			class="spinner-border spinner-border-sm me-2"
			role="status"
			aria-hidden="true"
		></span>
		{{ isLoading ? "Tallentaa..." : "Tallenna muutokset" }}
	</button>
</div>
